import { render, staticRenderFns } from "./ClientsTable.vue?vue&type=template&id=09f4fe3c&scoped=true&"
import script from "./ClientsTable.vue?vue&type=script&lang=ts&"
export * from "./ClientsTable.vue?vue&type=script&lang=ts&"
import style0 from "./ClientsTable.vue?vue&type=style&index=0&id=09f4fe3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f4fe3c",
  null
  
)

export default component.exports
import {QTable,QTr,QTd,QBtn} from 'quasar'
component.options.components = Object.assign({QTable,QTr,QTd,QBtn}, component.options.components || {})
